import { render } from "./SeoImageCell.vue?vue&type=template&id=2bb764b0&scoped=true"
import script from "./SeoImageCell.vue?vue&type=script&lang=js"
export * from "./SeoImageCell.vue?vue&type=script&lang=js"

import "./SeoImageCell.vue?vue&type=style&index=0&id=2bb764b0&lang=scss"
import "./SeoImageCell.vue?vue&type=style&index=1&id=2bb764b0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bb764b0"]])

export default __exports__